const AI_GENERATORS_BASE_PATH = 'ai-generators';

export const AI_ENDPOINTS = {
  presentationOptions: `${AI_GENERATORS_BASE_PATH}/presentation/options`,

  /**
   * @method POST - Generates a new email content using AI
   */
  bulkEmailAi: '/ai/bulks/email-variants',
  rateBulkEmailAiGenerated: '/ai/bulks/email-variants/rate',

  // Candidates
  candidatesPresentationMaker: 'ai/presentations/candidates',
  candidatesPresentationMakerV2: 'ai/presentations/v2/candidates',

  // Job Orders
  jobOrdersPresentationMaker: 'ai/presentations/job-orders',
  jobOrdersPresentationMakerV2: 'ai/presentations/v2/job-orders',
  ratePresentationMakerGenerated: 'ai/presentations/rate',

  // Prospecting Assistant
  prospectsSourcingByResponse: 'ai/inventory-sourcing/responses/:responseId',

  // Roleplay
  roleplayCalls: 'ai/roleplay/calls',
  roleplayCallDetails: 'ai/roleplay/calls/:id',
  roleplayCallTranscript: 'ai/roleplay/calls/:id/transcript',
  roleplayReportIssue: 'ai/roleplay/calls/:id/issue',
  roleplayMetrics: 'ai/roleplay/calls/metrics',
  roleplayCallVerbiages: 'ai/roleplay/calls/verbiages',

  // Summarize with AI
  summarizeReferenceCheck: '/reference-checks/:id/summary'
};
